module.exports = __webpack_public_path__ + "img/individual_address-08.36bf7f0d.svg";